import React, { useState } from 'react';
import Button from '../ui/Button';

const TemplateSelector = ({ templates, onSelect, onBack, loading }) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  
  const handleTemplateClick = (template) => {
    setSelectedTemplateId(template.id);
  };
  
  const handleContinue = () => {
    const selectedTemplate = templates.find(t => t.id === selectedTemplateId);
    if (selectedTemplate) {
      onSelect(selectedTemplate);
    }
  };
  
  // Render star rating
  const renderStars = (rating, count) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<span key={i} className="star">★</span>);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<span key={i} className="star">⯨</span>);
      } else {
        stars.push(<span key={i} className="star">☆</span>);
      }
    }
    
    return (
      <div className="template-rating">
        <div className="rating-stars">{stars}</div>
        {count && <div className="rating-count">({count})</div>}
      </div>
    );
  };
  
  if (loading) {
    return (
      <div className="template-selector">
        <h2>Select a Contract Template</h2>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading templates...</p>
        </div>
      </div>
    );
  }
  
  if (!templates || templates.length === 0) {
    return (
      <div className="template-selector">
        <h2>Select a Contract Template</h2>
        <p>No templates available. Please try again later.</p>
      </div>
    );
  }
  
  return (
    <div className="template-selector">
      <h2>Select a Contract Template</h2>
      <p>Choose a template to generate your contract. You'll be able to customize it in the next step.</p>
      
      <div className="template-grid">
        {templates.map(template => (
          <div 
            key={template.id}
            className={`template-card ${selectedTemplateId === template.id ? 'selected' : ''}`}
            onClick={() => handleTemplateClick(template)}
          >
            <div className="template-name">{template.name}</div>
            <div className="template-description">{template.description}</div>
            {renderStars(4.5, 120)} {/* Placeholder rating - would be dynamic in a real app */}
          </div>
        ))}
      </div>
      
      <div className="template-actions" style={{ marginTop: '2rem', display: 'flex', justifyContent: 'space-between' }}>
        {onBack && (
          <button 
            className="btn btn-secondary"
            onClick={onBack}
            disabled={loading}
          >
            Back
          </button>
        )}
        <button 
          className="btn btn-primary"
          onClick={handleContinue}
          disabled={!selectedTemplateId || loading}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default TemplateSelector;
